module.exports = __webpack_public_path__ + "09_hige_gray.55f1b300.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer3/09_hige_gray.png
// module id = +lxi
// module chunks = 0